


































































import { PropType } from 'vue';
import DocumentPreviewTable from './DocumentPreviewTable.vue';
import { SecureDocumentModel } from '../../../shared/models/secureDocument.model';
import { documentService } from '../../../shared/services/api/document.service';
import { types } from '../../../src_adm/store/types/types.js';
import { mapMutations } from 'vuex';
import { errorSubCodeTypes } from '../../../shared/enums/errorSubCodeTypes.js';
import chunk from 'lodash/chunk';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import Icon from '../../../shared/components/Icon.vue';
import { InstitutionProfileModel } from '../../../shared/models/institutionProfile.model';
import { DocumentWithChildrenModel } from '../../../shared/models/documentWithChildren.model';
import { CreateEsdhExportJobRequest } from '../../../shared/models/requests/createEsdhExportJob.request';
import { ESDHSecureDocumentExportRequest } from '../../../shared/models/requests/esdhSecureDocumentExport.request';

const EXPORT_TO_ESDH_CHUNK_SIZE = 10;

export default {
  components: { Icon, DocumentPreviewTable },
  props: {
    selectedDocuments: {
      type: Array as PropType<SecureDocumentModel[]>,
      default: () => [],
    },
    recipientSystemName: {
      type: String,
      default: '',
    },
  },
  emits: ['remove', 'sent'],
  data() {
    return {
      isShown: false,
      isLoading: false,
      childrenByDocument: new Map<number, number[]>(),
    };
  },
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
    headerTitle() {
      return this.$t('document.journalise_to_system', { system: this.recipientSystemName });
    },
  },
  methods: {
    ...mapMutations({
      setSucessText: types.MUTATE_SUCCESS_TEXT,
      setErrorText: types.MUTATE_ERROR_TEXT,
    }),
    populateChildrenByDocument() {
      this.resetChildrenByDocument();
      this.selectedDocuments.forEach(document => {
        this.childrenByDocument.set(
          document.id,
          document.associatedInstitutionProfiles.map((child: InstitutionProfileModel) => child.id)
        );
      });
    },
    handleJournalizedChildrenChanged(documentWithChildren: DocumentWithChildrenModel) {
      this.childrenByDocument.set(documentWithChildren.documentId, documentWithChildren.regardingChildrenIds);
    },
    async confirmSending() {
      await this.sendDocuments();
      this.hide();
      this.$refs.confirmSendingDocumentsToEsdhModal.hide();
    },
    cancelSending() {
      this.$refs.confirmSendingDocumentsToEsdhModal.hide();
    },
    onChangeShown(isShown: boolean) {
      if (!isShown) {
        this.isShown = false;
      }
    },
    show() {
      this.isShown = true;
    },
    hide() {
      this.isShown = false;
    },
    onRemove(documentId: number) {
      this.removeDocumentFromRequest(documentId);
      this.$emit('remove', documentId);
    },
    removeDocumentFromRequest(documentId: number) {
      this.childrenByDocument.delete(documentId);
    },
    resetChildrenByDocument() {
      this.childrenByDocument.clear();
    },
    async sendDocuments() {
      this.isLoading = true;
      const documentWithChildrenRequests: ESDHSecureDocumentExportRequest[] = this.getExportRequest();
      const documentWithChildrenRequestAsChunks = chunk(documentWithChildrenRequests, EXPORT_TO_ESDH_CHUNK_SIZE);

      const createExportRequests: CreateEsdhExportJobRequest[] = [];
      for (const requestChunk of documentWithChildrenRequestAsChunks) {
        createExportRequests.push({ secureDocumentsWithRegardingChildren: requestChunk });
      }
      try {
        const createExportJobPromises = createExportRequests.map((request: CreateEsdhExportJobRequest) =>
          documentService.exportDocumentsToEsdh(request)
        );
        await Promise.all(createExportJobPromises);
        this.$showToast(this.$t('warning.success_esdh_export', { systemName: this.recipientSystemName }));
        this.$emit('sent');
      } catch (error) {
        if (error.data.status.subCode === errorSubCodeTypes.canNotExportDocumentsFromMultipleDifferentMunicipalities) {
          this.setErrorText('API_ERROR_CAN_NOT_EXPORT_DOCUMENTS_FROM_MULTIPLE_DIFFERENT_MUNICIPALITIES');
        } else {
          this.setErrorText('API_ERROR_GENERAL');
        }
      }
      this.isLoading = false;
    },
    getExportRequest() {
      const requests: ESDHSecureDocumentExportRequest[] = [];

      for (const key of this.childrenByDocument.keys()) {
        const documentId = key;
        const childrenIds = this.childrenByDocument.get(documentId);
        requests.push({
          secureDocumentId: documentId,
          regardingChildrenIds: childrenIds,
        });
      }

      return requests;
    },
  },
};
